import { connect } from 'react-redux';
import { compose} from 'recompose';

import UserDetail from './UserDetail';

const mapStateToProps = state => ({
    data: state,
});

export default compose(
    connect(mapStateToProps),
)(UserDetail);
